import { forwardRef } from 'react'

import { IconProps, IconVariants } from '../IconVariants'
const StatusSuccessIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size, ...props }, ref) => {
  return (
    <svg
      aria-hidden="true"
      className={IconVariants({
        class: className,
        size,
      })}
      fill="none"
      height="1em"
      ref={ref}
      viewBox="0 0 24 24"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM17.8136 9.74264L10.7425 16.8137L6.49989 12.5711L7.9141 11.1569L10.7425 13.9842L16.3994 8.32843L17.8136 9.74264Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
})
StatusSuccessIcon.displayName = 'StatusSuccessIcon'
export default StatusSuccessIcon
